export default __webpack_public_path__ + "static/media/flower-3.86681368.svg";